import React, { Component } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import {
  selectAydinlatma,
  getAydinlatma,
  setAydinlatma,
  hideAydinlatmaModal
} from "../../../state/ducks/common/index";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    border: "none",
    padding: "0",
    background: "none"
  }
};

Modal.setAppElement("#app");

class AydinlatmaMetni extends Component {
  componentDidMount() {
    this.props.getAydinlatma();
  }

  hideModal = () => {
    this.props.setAydinlatma();
  };

  render() {
    
    const { aydinlatma } = this.props;
    return (
      <Modal
        isOpen={aydinlatma?.durum === false}
        onRequestClose={this.closeModal}
        style={{
          overlay: {
            position: 'fixed',

            inset: "0% 0% 0% 0%",
            left: 0,
            right: 0,

            bottom: 0,
            backgroundColor: 'unset !important'
          },
          content: {
            position: 'fixed',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            top: 0,
            left: 0,
            padding:"0px",
            border: '0px',
            backgroundColor: 'transparent' /* Black w/ opacity */

          }
        }}
      >

  {/* Bu kısım animasyon için Hareket eden kısım. */}
  <div className="t-modalContent" id="id-modalTipi" style={(window.innerWidth<=900)?{width:"89%"}: {width:"60%"}}>
    <div
      className="t-modal"
      id="id-modalGenel"
      style={{ backgroundColor: "rgb(255, 255, 255)" }}
    >
      <div className="container-fluid">
        {/* Header */}
        <div className="row t-modalHeader">
          <div
            className="col"
            id="id-modalHeader"
            style={{ color: "rgb(119, 119, 119)" }}
          >
            KİŞİSEL VERİLERİN KORUNMASI AYDINLATMA VE BİLGİLENDİRMESİ
          </div>
          <div className="col-auto t-cursorPointer">
            
          </div>
        </div>
        {/* Body */}
        <div className="row t-modalBody">
          <div
            className="col-12"
            id="id-modalBody"
            style={{ color: "rgb(119, 119, 119)" }}
          >
            Bu internet sitesine giren kişiler www.eminevim.com/kvkk metnindeki
            verilere ek olarak formu doldurmak suretiyle kişisel verilerinin ve
            hassas kişisel verilerinin aşağıda açıklanan amaçlar doğrultusunda
            kaydedilmesi, işlenmesi, aktarılması, silinmesi, yok edilmesi ve
            anonimleştirilmesi hakkında bilgilendirilmiş ve kabul etmişlerdir.
            İşbu bilgilendirme 6698 Sayılı Kişisel Verilerin Korunması
            Kanunu’nun 10.maddesinde düzenlenen Veri sorumlusunun aydınlatma
            yükümlülüğü hükümleri kapsamında yapılmaktadır.
            <br />
            <br />
            <strong>Kişisel Verilerinizin Kaydedilmesi:</strong>
            <br />
            Aşağıda başlıkları belirtilen kişisel verilerinizi kişisel veri
            envanterine kişisel veriler politikamızda belirtilen şekillerde
            kaydedilmektedir.
            <ol>
              <li>Genel Bilgilendirme Metnindeki Kişisel Veriler</li>
              <li>Ad</li>
              <li>Soyad</li>
              <li>Cep Telefonu Numarası</li>
              <li>e-posta adresi</li>
            </ol>
            Kişisel verileriniz nasıl elde edilip kaydedilmektedir? İnternet
            sitesi ziyaretçi bilgileriniz; google analytics, sosyal medya,
            dijital pazarlama kanalları ve benzeri yöntemler ile elde edildikten
            sonra, tarafınıza yönlendirilen iletişim formuna girdiğiniz kişisel
            veriler, veri tabanımıza güvenli yöntemler ile aktarılmakta ve
            kaydedilmektedir.
            <br />
            <br />
            <strong>Kişisel Verilerinizin İşlenmesi:</strong>
            <br />
            Bu kapsamda, kişisel verileriniz aşağıdaki amaçlar doğrultusunda
            işlenmektedir.
            <ol>
              <li>Kurum içerisinde olanların can ve mal güvenliğini korumak</li>
              <li>
                Türk Ceza Kanunu, Kabahatler Kanunu, Borçlar Kanunu, Türk
                Ticaret Kanunu, İş Kanunu, 5651 Sayılı Kanun, 5549 sayılı Suç
                Gelirlerinin Aklanmasının Önlenmesi Hakkında Kanun başta olmak
                üzere ilgili mevzuat ihlalleri halinde yasayla yetkilendirilmiş
                kurumlarla, mahkemelerle ve savcılıklarla delil paylaşmak,
              </li>
              <li>
                Şirket iç politika veya standart ihlallerinin tespiti,
                araştırılması ve önlenmesi,
              </li>
              <li>
                Şirket’in ana faaliyet konusundaki hizmetlerinin yönetilmesi ve
                yürütülmesi, verilerin merkezileştirilmesi
              </li>
              <li>
                Şirket’in sözleşmesel yükümlülüklerinin yerine getirilmesi,
              </li>
              <li>
                Verilerin analiz edilerek şirket ve internet sitesindeki
                hizmetlerin geliştirilmesi
              </li>
              <li>
                İletişim formunu dolduran kişilere daha hızlı ve etkin bir
                şekilde hizmet verilmesi
              </li>
            </ol>
            <strong>
              Kişisel Verilerin Silinmesi, Yok Edilmesi ve Anonimleştirilmesi:
            </strong>
            <br />
            Kişisel veri envanterimizde yer alan bu veriler, Şirket
            Politikalarımızda düzenlendiği şekilde mevzuat ile öngörülen saklama
            süreleri veya işleme nedeni geçerli olduğu süre boyunca saklanacak
            ve bu sürenin sona ermesinden sonra silinecektir.
            <br />
            <br />
            <strong>Kişisel Verilerinizin Aktarılması:</strong>
            <br />
            Şirket ziyaret kaydınızla ilişkin kişisel veriler aşağıdaki kişi ve
            kuruluşlara aktarılabilecektir.
            <ol>
              <li>Şirket Yönetim ve İcra Kurulu</li>
              <li>Şirket Kurumsal İletişim ve Pazarlama Bölümü</li>
              <li>Şirket Bilgi Teknolojileri Bölümü</li>
              <li>Şirket Satış Bölümü</li>
              <li>Şirket İç Denetim Bölümü</li>
              <li>Şirket İdari İşler Bölümü</li>
              <li>
                Şirket bünyesinde çalışan veya sözleşmeli kurum avukatları
              </li>
              <li>Kolluk kuvvetleri</li>
              <li>Mahkemeler</li>
              <li>Savcılıklar</li>
              <li>Yasayla yetkilendirilmiş kurumlar</li>
              <li>Özel bilgi güvenliği şirketi yönetimi</li>
            </ol>
            <strong>Kişisel Verilerinizin Güvenliği:</strong>
            <br />
            Bilgi Güvenliği Politikasında belirtildiği Şirket kişisel veri
            işleme faaliyetlerini yürütürken uygun güvenlik düzeyini temin
            etmeye yönelik aşağıdaki konulardaki her türlü teknik ve idari
            tedbirleri almaktadır.
            <ol>
              <li>
                Kişisel verilerin hukuka aykırı olarak işlenmesini önlemek
              </li>
              <li>
                Kişisel verilere hukuka aykırı olarak erişilmesini önlemek
              </li>
              <li>Kişisel verilerin muhafazasını sağlamak</li>
            </ol>
            <strong>Haklarınız:</strong>
            <br />
            Şirket tarafından verilerinizin işlendiği ve Şirket’in verilerinizi
            veri sorumlusu sıfatı ile işlediği ölçüde kişisel verileriniz
            bakımından aşağıdaki haklara sahipsiniz;
            <ol>
              <li>
                Herhangi bir kişisel verinizin işlenip işlenmediğini öğrenme,
              </li>
              <li>
                Kişisel verilerinizin işlenme faaliyetlerine ilişkin olarak
                bilgi talep etme,
              </li>
              <li>Kişisel verilerinizin işlenme amaçlarını öğrenme,</li>
              <li>
                Kişisel verilerin yurt içinde veya yurt dışında üçüncü kişilere
                aktarılmış olması durumunda bu kişileri öğrenme,
              </li>
              <li>
                Kişisel verilerin eksik veya yanlış işlenmiş olması halinde
                bunların düzeltilmesini isteme,
              </li>
              <li>
                Kişisel verilerin işlenmesini gerektiren sebeplerin ortadan
                kalkması veya Şirket’in söz konusu verileri işleyebilmek için
                hukuki dayanağı veya meşru menfaatinin bulunmaması halinde
                kişisel verilerin silinmesini veya yok edilmesini isteme,
              </li>
              <li>
                Şirket’ten, yine Şirket tarafından yetkilendirilen ve kişisel
                verileri işleyen üçüncü kişilerin bu bölüm kapsamındaki
                haklarınıza saygı duymasını sağlamasını talep etme,
              </li>
              <li>
                Kişisel verilerin otomatik sistemler vasıtasıyla işlenmesi
                sonucu ortaya çıkabilecek aleyhte sonuçlara itiraz etme,
              </li>
              <li>
                Kişisel verilerinizin kanuna aykırı bir şekilde işlenmesi
                sebebiyle zarara uğramanız halinde bu zararın tazmin edilmesini
                isteme.
              </li>
            </ol>
            <strong>Veri Sorumlusu Bilgilendirmesi:</strong>
            <br />
            Aşağıda detaylı kurumsal bilgileri yayınlanan Şirket ve iş ortakları
            olarak, 6698 sayılı Kişisel Verilerin Korunması Kanunu uyarınca Veri
            Sorumlusu sıfatıyla kişisel verilerinizi ilgili mevzuata uygun
            olarak kullanacağız.
            <br />
            Veri Sorumlusuna Başvuru Usulü - 6698 sayılı Kişisel Verilerin
            Korunması Kanunu 13’üncü maddesinin birinci fıkrası uyarınca; veri
            sorumlusu olan Şirketimize bu haklara ilişkin olarak yapılacak
            başvuruların yazılı olarak veya Kişisel Verilerin Korunması Kurulu
            (“Kurul”) tarafından belirlenen diğer yöntemlerle tarafımıza
            iletilmesi gerekmektedir. Bu çerçevede “yazılı” olarak Şirketimize
            yapılacak başvurular aşağıdaki şekilde yapılabilir.
            <ol>
              <li>Başvuru Sahibinin şahsen başvurusu ile</li>
              <li>Noter vasıtasıyla,</li>
              <li>
                Başvuru Sahibi tarafından 5070 Sayılı Elektronik İmza Kanununda
                tanımlı olan “güvenli elektronik imza” ile imzalanarak Şirket
                kayıtlı elektronik posta adresine gönderilmek suretiyle,
              </li>
              <li>İnternet sitesindeki KVK başvuru formu ile</li>
              <li>Aşağıdaki e-posta adresine gönderilecek e-posta ile</li>
              <li>
                Aşağıdaki fiziki posta adresine gönderilecek imzalı posta veya
                kargo ile
              </li>
            </ol>
            <table className="table table-sm t-tablo">
              <thead>
                <tr className="bg-light">
                  <th scope="col">Ünvan</th>
                  <th scope="col">Posta Adresi</th>
                  <th scope="col">Mersis No</th>
                </tr>
              </thead>
              <tbody className="text-left">
                <tr>
                  <td>
                    EMİN EVİM EMİN OTOMOTİV İLETİŞİM ORG. SAN. VE TİC. A.Ş
                  </td>
                  <td>Altunizade Mah. Kısıklı Cad. No: 36 Üsküdar/İstanbul</td>
                  <td>0333072097900104</td>
                </tr>
                <tr>
                  <td>GENTAŞ TAAHHÜT İNŞAAT A.Ş</td>
                  <td>Altunizade Mah. Kısıklı Cad. No:36/1 Üsküdar/İstanbul</td>
                  <td>0333071916942659</td>
                </tr>
                <tr>
                  <td>EMİN SİGORTA ARACILIK HİZMETLERİ LTD. ŞTİ</td>
                  <td>
                    Zühtü Paşa Mah. Fahrettin Kerim Gökay Cad. No:36 A
                    Kadıköy/İstanbul
                  </td>
                  <td>0333009367800013</td>
                </tr>
                <tr>
                  <td>EMİN İKİNCİ EL OTOMOTİV LTD. ŞTİ</td>
                  <td>Barbaros Mah. Nuhkuyusu Cad. No:52/3 Üsküdar/İstanbul</td>
                  <td>0314060710500018</td>
                </tr>
                <tr>
                  <td>EMİN TARIM VE ENERJİ SAN. VE TİC. A.Ş</td>
                  <td>Barbaros Mah. Nuhkuyusu Cad. No:52/3 Üsküdar/İstanbul</td>
                  <td>0333008715500016</td>
                </tr>
                <tr>
                  <td>EMİN ENTEGRE BESİCİLİK GIDA VE TARIM SAN. TİC. A.Ş</td>
                  <td>Altunizade Mah. Kısıklı Cad. No:36/1 Üsküdar/İstanbul</td>
                  <td>0333071456600019</td>
                </tr>
              </tbody>
            </table>
            <br />
            <div className="w-100">
              <button className="t-icButtonYesil mx-auto"
              onClick={() => this.hideModal()}>
                <span>Onaylıyorum</span>
                <i className="t-icon-done_outline" />
              </button>
            </div>
          </div>
        </div>
        {/* footer*/}
        <div className="row t-modalFooter">
          <div
            className="col-12"
            id="id-modalFooter"
            style={{ color: "rgb(102, 102, 102)" }}
          >
            <p>
              <strong>E-Posta Adresi:</strong>{" "}
              <a href="mailto:kvkk@eminevim.com.tr">kvkk@eminevim.com.tr</a>
              <br />
              <strong>Veri Sorumlusu Adı-Soyadı:</strong>&nbsp;&nbsp;EMİN EVİM
              EMİN OTOMOTİV İLETİŞİM ORG. SAN. VE TİC. A.Ş
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>


      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    aydinlatma: selectAydinlatma(state)
  };
};

const mapDispatchToProps = dispatch => ({
  hideAydinlatmaModal: () => dispatch(hideAydinlatmaModal()),
  getAydinlatma: () => dispatch(getAydinlatma()),
  setAydinlatma: () => dispatch(setAydinlatma())
});

export default connect(mapStateToProps, mapDispatchToProps)(AydinlatmaMetni);
